import { Component, OnInit, Input, OnChanges, SimpleChanges, HostListener, ElementRef, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SelectModel } from '../../models/select-model';
import { DisplayText } from 'src/app/models/events/displayText';
import { CoreEnum } from 'src/app/enums/core.enum';


@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectComponent implements OnInit, OnChanges {

  @Input() model: SelectModel;
  @Output() changedValueEventEmitter = new EventEmitter<DisplayText>();

  coreEnum = CoreEnum;

  constructor(private eRef: ElementRef) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && changes.model.currentValue) {
    }
  }

  /**
   *
   * @param event If click out of the select: hide
   */
  @HostListener('document:click', ['$event'])
  clickout(event): void {
    if (this.model && !this.eRef.nativeElement.contains(event.target)) {
      this.hideOptions();
    }
  }

  onClickSelect(): void {
    if (!this.model.disabled) {
      this.OpenToggle();
    }
  }

  OpenToggle(): void {
    if (this.model.opened) {
      this.hideOptions();
    } else {
      this.showOptions();
    }
  }

  onSelectedOption(option: DisplayText): void {
    this.model.selected = option;
    this.changedValueEventEmitter.emit(option);
    this.hideOptions();
  }

  hideOptions(): void {
    this.model.opened = false;
  }

  showOptions(): void {
    this.model.opened = true;
  }
}
